import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, OnChanges } from '@angular/core';
import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';
import '@maersk-global/mds-components-core/mc-table';
import { MaintenanceOrderPart } from '../../../../models/maintenance-order-part';
import { TagInputComponent } from '../../../../shared-components/tag-input/tag-input.component';
import { AuthPolicies } from '../../../../auth/auth-policies';
import { MaintenanceOrderStatusCode } from '../../../../models/maintenance-order-status.model';
import { utils } from '../../../../helper/utils';

type repairPartRow = {
  id: string;
  partNumber: string;
  partName: string;
  unitQuantity: number;
  unitPrice: number;
  partTotal: number;
  part: MaintenanceOrderPart;
};

@Component({
  selector: 'app-list-repair-part-items',
  imports: [TagInputComponent],
  templateUrl: './list-repair-part-items.component.html',
  styleUrls: ['./list-repair-part-items.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ListRepairPartItemsComponent implements OnChanges {
  @Input({ required: true }) repairParts: MaintenanceOrderPart[] = [];
  @Input({ required: true }) maintainceOrderStatus?: MaintenanceOrderStatusCode;
  @Input() maintenanceOrderSourceApplication: string | undefined = '';
  rows: repairPartRow[] = [];
  partsTableColumns: Array<TableColumn> = [
    { id: 'partNumber', label: 'Part Number', sortDisabled: true },
    { id: 'partName', label: 'Part Description', sortDisabled: true },
    { id: 'unitQuantity', label: 'Pcs', sortDisabled: true, align: 'right' },
    { id: 'unitPrice', label: 'Part Cost/pc', sortDisabled: true, align: 'right' },
    { id: 'partTotal', label: 'Part Total', sortDisabled: true, align: 'right' },
    { id: 'currentSerialNumbers', label: 'Old Part Serial Number', sortDisabled: true },
    { id: 'newSerialNumbers', label: 'New Part Serial Number', sortDisabled: true },
  ];

  constructor(public authPolicy: AuthPolicies) {}

  ngOnChanges() {
    this.rows = this.repairParts.map((part, index) => ({
      id: `part${index}`,
      partNumber: part.partNumber,
      partName: part.partName ?? '-',
      unitQuantity: part.unitQuantity,
      unitPrice: utils.formatNumberToTwoDigitDecimal(part.unitPrice),
      partTotal: utils.formatNumberToTwoDigitDecimal(part.unitPrice * part.unitQuantity),
      part,
    }));
  }
  isSerialNumberEditable() {
    return (
      this.maintainceOrderStatus === 390 &&
      this.authPolicy.canEditWorkOrder &&
      this.maintenanceOrderSourceApplication !== 'MNR' &&
      this.maintenanceOrderSourceApplication !== 'eEIR' &&
      this.maintenanceOrderSourceApplication !== 'Vessel-WorkOrder-Upload-Job'
    );
  }
  onNewSerialNumbersChanged(part: MaintenanceOrderPart, value: string[]) {
    part.newSerialNumbers = value;
  }
}
